import React from "react";
import { LimaShopID } from "../../utils/Constants";
import "./ShopLogo.css";

const ShopLogo = ({ shopID }) => {
  let url = null;

  switch (shopID) {
    case LimaShopID.Apotea:
    case LimaShopID.Vitaminvaruhuset:
      url = "/images/apotea.svg";
      break;
    case LimaShopID.Babyland:
      url = "/images/babyland-logo.svg";
      break;
    case LimaShopID.BabylandNo:
      url = "/images/babyland-no-logo.svg";
      break;
    case LimaShopID.StorOchLiten:
      url = "/images/storochliten-logo.svg";
      break;
    case LimaShopID.LitenLeker:
      url = "/images/litenleker-logo.svg";
      break;
    case LimaShopID.Lekia:
    case LimaShopID.LekiaNo:
      url = "/images/lekia-logo.png";
      break;
    case LimaShopID.HappyYachting:
    case LimaShopID.HappyYachtingNo:
      url = "/images/happy_st_pos_blue.svg";
      break;
    case LimaShopID.SmartaSaker:
    case LimaShopID.SmartaSakerNo:
    case LimaShopID.SmartaSakerCom:
      url = "/images/smartasaker_logo.png";
      break;
    case LimaShopID.WidForss:
      url = "/images/Widforss-logo.png";
      break;
    case LimaShopID.WidforssNo:
      url = "/images/WidforssNOWeblogo.png";
      break;
    case LimaShopID.Delitea:
      url = "/images/delitea-logo2.png";
      break;
    case LimaShopID.Retkitukku:
      url = "/images/retkitukku-logo.png";
      break;
    case LimaShopID.Koiravaruste:
      url = "/images/koiravaruste-logo.png";
      break;
    default:
      url = null;
      break;
  }

  if (url === null) {
    return null;
  }

  return (
    <img className={`ShopLogo logo-${shopID}`} src={process.env.PUBLIC_URL + url} alt="Logga"></img>
  );
};

export default ShopLogo;
